import { RichText } from "@wordpress/block-editor";

function Save({ attributes }) {
  const { quotation,
          name,
          textColorClass } = attributes;

  return (
    <div className={`pullquote`}>
      <RichText.Content
        tagName="p"
        className={`pullquote subhead ${textColorClass}`}
        value={quotation}
      />
      <RichText.Content
        tagName="p"
        className={`pullquote-name subhead ${textColorClass}`}
        value={name}
      />
    </div>
  );
}

export default Save;
